import { BRAND_COLOR } from "@/app/layout/LayoutConstants";
import Ribbon from "../common/Ribbon";
import { Box } from "@mui/material";
import { AdOttLogo } from "./AdOttLogo";

export interface AdLabelRibbonProps {
  isUrgent: boolean;
  isSold: boolean;
  adTypeLabel: string;
  isRvOtt: boolean;
}

export default function AdLabelRibbon({
  ad,
  alwaysSmall,
  isSearchResult,
  isOnGrey,
}: {
  ad: AdLabelRibbonProps;
  alwaysSmall?: boolean;
  isSearchResult?: boolean;
  isOnGrey?: boolean;
}) {
  return (
    <Box>
      {ad.isUrgent && !ad.isSold ? (
        <Ribbon
          background={BRAND_COLOR}
          alwaysSmall={alwaysSmall}
          orientation="left"
        >
          URGENT
        </Ribbon>
      ) : (
        <>
          {ad.adTypeLabel ? (
            <Ribbon
              background="black"
              alwaysSmall={alwaysSmall}
              orientation="left"
            >
              <small>{ad.adTypeLabel.toUpperCase()}</small>
            </Ribbon>
          ) : (
            ad.isRvOtt && <AdOttLogo alwaysSmall={alwaysSmall} isSearchResult={isSearchResult} isOnGrey={isOnGrey} />
          )}
        </>
      )}
    </Box>
  );
}
